/*!
 * Stimpack Slider
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

import { spBase64Decode } from '../utilities/utilities';

(function($){

    var spSlider = function(el, options) {

		var root = $(el),
			slider = root.find('.sp-slider-inner'),
			sliderControls = root.find('.sp-slider-controls');

		if (sliderControls.length < 1)
		{
			sliderControls = $('<div class="sp-slider-controls-wrap"><div class="sp-slider-controls"><div class="sp-slider-controls-inner"><div class="sp-slider-arrows"></div></div></div></div>');
		}

		root.append(sliderControls);

		options = $.extend({}, {
			dots: true,
			arrows: false,
			appendDots: sliderControls.find('.sp-slider-controls-inner'),
			appendArrows: sliderControls.find('.sp-slider-arrows'),
			pauseOnHover: false,
			prevArrow: '<button type="button" class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 8" style="enable-background:new 0 0 50 8;" xml:space="preserve"><path d="M49.4,3.5H1.8l2.7-2.7c0.2-0.2,0.2-0.5,0-0.6S4,0,3.8,0.2L0,4l3.8,3.8C3.9,7.9,4,7.9,4.1,7.9s0.2,0,0.3-0.1 c0.2-0.2,0.2-0.5,0-0.6L1.8,4.5h47.7c0.3,0,0.5-0.2,0.5-0.5C49.9,3.7,49.7,3.5,49.4,3.5z"/></svg></button>',
			nextArrow: '<button type="button" class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 8" style="enable-background:new 0 0 50 8;" xml:space="preserve"><path d="M0.6,3.5h47.7l-2.7-2.7c-0.2-0.2-0.2-0.5,0-0.6s0.5-0.2,0.6,0L50,4l-3.8,3.8c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1 c-0.2-0.2-0.2-0.5,0-0.6l2.7-2.7H0.6C0.3,4.5,0.1,4.3,0.1,4C0.1,3.7,0.3,3.5,0.6,3.5z"/></svg></button>',
			customPaging: function(slider, i) {

				var slide = root.find('.slide-' + i),
					text = slide.length > 0
						? slide.data('slider-pagination')
						: '';

				text = text ? ' <span class="slick-dot-text">' + text +
					'</span>' : '';

				return $('<button type="button"><span class="slick-dot-number">' +
					(i < 9 ? '0' : '') + (i + 1) + '</span>' + text +
					'</button>');
			},
			progressBar: false,
			autoplaySpeed: 2000
		}, options);


		if (options.progressBar)
        {
			var progressBar = $(options.progressBar);

			$('head').append('<style class="sp-slider"> ' +
				//options.progressBar + ' > div { transition: all .5s); }' +
				options.progressBar + '.active > div { transition: all ' +
				(options.autoplaySpeed / 1000) + 's } </style>');

			slider.on('beforeChange',
				function(event, slick, currentSlide, nextSlide) {
					progressBar.removeClass('active');
				});

			slider.on('init afterChange',
				function(event, slick, currentSlide, nextSlide) {
					progressBar.addClass('active');
				});
		}

        slider.on('init', function() {
            root.addClass('sp-slider-initiated');
        })

		slider.slick(options);
	};

	$('[data-sp-slider]').each(function() {
        var options = $(this).data('sp-slider') || {};
		return new spSlider(this, JSON.parse(spBase64Decode(options)));
	});

})(jQuery);
